/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Article from '../components/Feature/Article/Article';
import ArticleList from '../components/Feature/Article/Article List';
import ArticlesRollup from '../components/Feature/Article/Articles Rollup';
import AuthorArticlesRollup from '../components/Feature/Author/Author Articles Rollup';
import AuthorCopy from '../components/Feature/Author/Author Copy';
import AuthorPageArticles from '../components/Feature/Author/Author Page Articles';
import CookieBanner from '../components/Feature/Basic/CookieBanner';
import IntroOneColumn from '../components/Feature/Basic/Intro One Column';
import IntroTwoColumn from '../components/Feature/Basic/Intro Two Column';
import PageTitle from '../components/Feature/Basic/Page Title';
import ContactResidenceListing from '../components/Feature/Book a Visit/Contact Residence Listing';
import ThankYouMessage from '../components/Feature/Book a Visit/Thank You Message';
import ContentBlock from '../components/Feature/ContentBlock/ContentBlock';
import BasicCTA from '../components/Feature/CTA/Basic CTA';
import GalleryCTA from '../components/Feature/CTA/Gallery CTA';
import ResidenceBookaVisitCTA from '../components/Feature/CTA/Residence Book a Visit CTA';
import ResidencePhoneCTA from '../components/Feature/CTA/Residence Phone CTA';
import VideoCTA from '../components/Feature/CTA/Video CTA';
import EventDetails from '../components/Feature/Event/Event Details';
import EventsList from '../components/Feature/Event/Events List';
import EventsRollup from '../components/Feature/Event/Events Rollup';
import FAQAccordion from '../components/Feature/FAQ/FAQ Accordion';
import FAQContainer from '../components/Feature/FAQ/FAQ Container';
import Form from '../components/Feature/Forms/Form';
import GraphQLConnectedDemo from '../components/Feature/GraphQL/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/Feature/GraphQL/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/Feature/GraphQL/GraphQL-Layout';
import EmbeddedMedia from '../components/Feature/Media/Embedded Media';
import FullPanelVideo from '../components/Feature/Media/Full Panel Video';
import GoogleMap from '../components/Feature/Media/Google Map';
import HeroBanner from '../components/Feature/Media/Hero Banner';
import Image from '../components/Feature/Media/Image';
import MosaicGallery from '../components/Feature/Media/Mosaic Gallery';
import NewHeroBanner from '../components/Feature/Media/New Hero Banner';
import NotificationBanner from '../components/Feature/Media/Notification Banner';
import PencilBanner from '../components/Feature/Media/Pencil Banner';
import QuoteProof from '../components/Feature/Media/Quote Proof';
import SplitScreenBanner from '../components/Feature/Media/Split Screen Banner';
import MediaHitsArticle from '../components/Feature/Media Hits/Media Hits Article';
import MediaHitsCardList from '../components/Feature/Media Hits/Media Hits Card List';
import Breadcrumbs from '../components/Feature/Navigation/Breadcrumbs';
import CorporateNavigation from '../components/Feature/Navigation/Corporate Navigation';
import Footer from '../components/Feature/Navigation/Footer';
import ResidenceNavigation from '../components/Feature/Navigation/Residence Navigation';
import CTAPanel from '../components/Feature/Panel/CTA Panel';
import DifferentiatorPanel from '../components/Feature/Panel/Differentiator Panel';
import FloorPlanPanel from '../components/Feature/Panel/Floor Plan Panel';
import ModalContainer from '../components/Feature/Panel/Modal Container';
import NavigationPanel from '../components/Feature/Panel/Navigation Panel';
import NavigationPanelContainer from '../components/Feature/Panel/Navigation Panel Container';
import TestimonialPanel from '../components/Feature/Panel/Testimonial Panel';
import ResidenceList from '../components/Feature/Residence/Residence List';
import ArticleSearchResults from '../components/Feature/Search/Article Search Results';
import CludoSearchResults from '../components/Feature/Search/Cludo Search Results';
import FeaturedSearch from '../components/Feature/Search/Featured Search';
import FindResidenceSearchBar from '../components/Feature/Search/Find Residence Search Bar';
import FindResidenceSearchBox from '../components/Feature/Search/Find Residence Search Box';
import FindResidenceSearchResults from '../components/Feature/Search/Find Residence Search Results';
import HeroBannerFindResidenceSearchBar from '../components/Feature/Search/Hero Banner Find Residence Search Bar';
import MainSearchBox from '../components/Feature/Search/Main Search Box';
import NavigationSearchBox from '../components/Feature/Search/Navigation Search Box';
import ResidenceSearchResults from '../components/Feature/Search/Residence Search Results';
import StyleguideComponentParams from '../components/Feature/Styleguide/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../components/Feature/Styleguide/Styleguide-CustomRouteType';
import StyleguideFieldUsageCheckbox from '../components/Feature/Styleguide/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../components/Feature/Styleguide/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../components/Feature/Styleguide/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../components/Feature/Styleguide/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../components/Feature/Styleguide/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../components/Feature/Styleguide/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../components/Feature/Styleguide/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../components/Feature/Styleguide/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../components/Feature/Styleguide/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../components/Feature/Styleguide/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../components/Feature/Styleguide/Styleguide-FieldUsage-Text';
import StyleguideLayout from '../components/Feature/Styleguide/Styleguide-Layout';
import StyleguideLayoutReuse from '../components/Feature/Styleguide/Styleguide-Layout-Reuse';
import StyleguideLayoutTabs from '../components/Feature/Styleguide/Styleguide-Layout-Tabs';
import StyleguideLayoutTabsTab from '../components/Feature/Styleguide/Styleguide-Layout-Tabs-Tab';
import StyleguideMultilingual from '../components/Feature/Styleguide/Styleguide-Multilingual';
import StyleguideRouteFields from '../components/Feature/Styleguide/Styleguide-RouteFields';
import StyleguideSection from '../components/Feature/Styleguide/Styleguide-Section';
import StyleguideSitecoreContext from '../components/Feature/Styleguide/Styleguide-SitecoreContext';
import StyleguideTracking from '../components/Feature/Styleguide/Styleguide-Tracking';
import TwoColumnSublayout from '../components/Project/Amica/Two Column Sublayout';

const components = new Map();
components.set('Article', Article);
components.set('Article List', ArticleList);
components.set('Articles Rollup', ArticlesRollup);
components.set('Author Articles Rollup', AuthorArticlesRollup);
components.set('Author Copy', AuthorCopy);
components.set('Author Page Articles', AuthorPageArticles);
components.set('CookieBanner', CookieBanner);
components.set('Intro One Column', IntroOneColumn);
components.set('Intro Two Column', IntroTwoColumn);
components.set('Page Title', PageTitle);
components.set('Contact Residence Listing', ContactResidenceListing);
components.set('Thank You Message', ThankYouMessage);
components.set('ContentBlock', ContentBlock);
components.set('Basic CTA', BasicCTA);
components.set('Gallery CTA', GalleryCTA);
components.set('Residence Book a Visit CTA', ResidenceBookaVisitCTA);
components.set('Residence Phone CTA', ResidencePhoneCTA);
components.set('Video CTA', VideoCTA);
components.set('Event Details', EventDetails);
components.set('Events List', EventsList);
components.set('Events Rollup', EventsRollup);
components.set('FAQ Accordion', FAQAccordion);
components.set('FAQ Container', FAQContainer);
components.set('Form', Form);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('Embedded Media', EmbeddedMedia);
components.set('Full Panel Video', FullPanelVideo);
components.set('Google Map', GoogleMap);
components.set('Hero Banner', HeroBanner);
components.set('Image', Image);
components.set('Mosaic Gallery', MosaicGallery);
components.set('New Hero Banner', NewHeroBanner);
components.set('Notification Banner', NotificationBanner);
components.set('Pencil Banner', PencilBanner);
components.set('Quote Proof', QuoteProof);
components.set('Split Screen Banner', SplitScreenBanner);
components.set('Media Hits Article', MediaHitsArticle);
components.set('Media Hits Card List', MediaHitsCardList);
components.set('Breadcrumbs', Breadcrumbs);
components.set('Corporate Navigation', CorporateNavigation);
components.set('Footer', Footer);
components.set('Residence Navigation', ResidenceNavigation);
components.set('CTA Panel', CTAPanel);
components.set('Differentiator Panel', DifferentiatorPanel);
components.set('Floor Plan Panel', FloorPlanPanel);
components.set('Modal Container', ModalContainer);
components.set('Navigation Panel', NavigationPanel);
components.set('Navigation Panel Container', NavigationPanelContainer);
components.set('Testimonial Panel', TestimonialPanel);
components.set('Residence List', ResidenceList);
components.set('Article Search Results', ArticleSearchResults);
components.set('Cludo Search Results', CludoSearchResults);
components.set('Featured Search', FeaturedSearch);
components.set('Find Residence Search Bar', FindResidenceSearchBar);
components.set('Find Residence Search Box', FindResidenceSearchBox);
components.set('Find Residence Search Results', FindResidenceSearchResults);
components.set('Hero Banner Find Residence Search Bar', HeroBannerFindResidenceSearchBar);
components.set('Main Search Box', MainSearchBox);
components.set('Navigation Search Box', NavigationSearchBox);
components.set('Residence Search Results', ResidenceSearchResults);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Tracking', StyleguideTracking);
components.set('Two Column Sublayout', TwoColumnSublayout);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
